export const setItem = (key: string, value: any, inSession = false) => {
  const fullKey = `nftx.${key}`;
  if (inSession) sessionStorage.setItem(fullKey, value);
  else localStorage.setItem(fullKey, value);
};
